import { Table, Empty } from "antd";
import Loader from "./Loader";

export default function AppTable({
  columns = [],
  data = [],
  loading = false,
  rowKey = "id",
  pagination = { pageSize: 10 },
}) {
  return (
    <div>
      {loading && <Loader fullScreen />}
      <Table
        columns={columns}
        dataSource={data}
        rowKey={rowKey}
        pagination={pagination}
        size="small"
        locale={{
          emptyText: <Empty description="No data found" />,
        }}
      />
    </div>
  );
}
